@if($captainMarker | async; as captain){
<h1 class="text-2xl text-center self-center tablet:text-3xl">{{captainText}} <span
        class="text-yellow-400 bold">{{captain.captain_name}}</span></h1>
}@else {
<h1 class="text-2xl text-center self-center tablet:text-3xl">{{seaTowText}}<span class="text-yellow-400 bold"> {{captainText}}</span>
</h1>
}
